import { Tasks as TasksImported } from "features/Tasks/components/Tasks";

export const Tasks = TasksImported;
